import { useState, useEffect } from 'react';
import { useBrandApi, useCampaignApi, type BrandSummary } from '../../services/apiService';
import { type Campaign } from './types';
import { getCampaignStatus } from './utils';

export function useCampaignData() {
    const { getCampaigns, deleteCampaign, getRecentActivity } = useCampaignApi();
    const { getBrands } = useBrandApi();
  
    const [campaigns, setCampaigns] = useState<Campaign[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [brands, setBrands] = useState<BrandSummary[]>([]);
    const [conceptOptions, setConceptOptions] = useState<string[]>([]);
    const [recentActivity, setRecentActivity] = useState<Campaign[]>([]);

    useEffect(() => {
    const loadData = async () => {
            setLoading(true);
        setError(null);
            
 try {
         const [campaignsData, recentData, brandData] = await Promise.all([
          getCampaigns(),
         getRecentActivity(),
       getBrands()
             ]);

        const mappedCampaigns = campaignsData.map((c: any) => {
        const status = getCampaignStatus(c.startDate, c.endDate);
   return {
             id: Number(c.id),
         name: c.name,
            businessUnit: c.businessUnit,
         category: c.category,
   brandId: Number(c.brandId),
       brandName: c.brandName || '',
            concept: c.concept,
          status,
          startDate: c.startDate,
              endDate: c.endDate,
    year: new Date(c.startDate).getFullYear(),
        budget: c.budget,
        targetProfile: c.targetProfile,
           campaignType: c.campaignType,
                platforms: c.platforms || [],
    products: c.products || [],
      description: c.description,
               image: c.imageUrl || c.image || '',
         };
      });

         const mappedRecentActivity = recentData.map((c: any) => {
        const status = getCampaignStatus(c.startDate, c.endDate);
           return {
       id: Number(c.id),
          name: c.name,
    businessUnit: c.businessUnit,
     category: c.category,
       brandId: Number(c.brandId),
    brandName: c.brandName || '',
   concept: c.concept,
               status,
         startDate: c.startDate,
              endDate: c.endDate,
   year: new Date(c.startDate).getFullYear(),
   budget: c.budget,
        targetProfile: c.targetProfile,
      campaignType: c.campaignType,
      platforms: c.platforms || [],
       products: c.products || [],
         description: c.description,
         image: c.imageUrl || c.image || '',
        updatedAt: c.updatedAt,
           createdAt: c.createdAt,
       };
   });

const conceptTitles = Array.from(new Set(
   mappedCampaigns
           .map(c => c.concept)
    .filter(Boolean)
                )).sort((a, b) => a.localeCompare(b));

      setCampaigns(mappedCampaigns);
setRecentActivity(mappedRecentActivity);
                setBrands((brandData ?? []).slice().sort((a, b) => a.name.localeCompare(b.name)));
       setConceptOptions(conceptTitles);
 } catch (err) {
        setError('Failed to load campaign data');
     console.error('Error loading campaign data:', err);
       } finally {
         setLoading(false);
            }
        };

        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDeleteCampaign = async (campaignId: number) => {
        try {
    await deleteCampaign(campaignId);
     setCampaigns(prev => prev.filter(c => c.id !== campaignId));
  setRecentActivity(prev => prev.filter(c => c.id !== campaignId));
   } catch {
            setError('Failed to delete campaign');
        }
    };

    return {
        campaigns,
        loading,
        error,
 brands,
        conceptOptions,
        recentActivity,
        handleDeleteCampaign,
     setError
    };
}
